// extracted by mini-css-extract-plugin
export default {"emptyState":"EmptyState_emptyState__QYbLl","card":"EmptyState_card__plLTu","fullscreen":"EmptyState_fullscreen__b3J08","standardConfetti":"EmptyState_standardConfetti__2DAvb"};